import { getYesOrNoOptions } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { YesOrNoType } from 'types/yesOrNo';

import {
  Field,
  useFormContext,
  maxLengthTextField,
} from '../../../forms/companyGlobalFinancialMonitoringPartOneForm';

export interface FormContentProps {}

export const FormContent = () => {
  const { t } = useTranslation();
  const { values } = useFormContext();

  return (
    <>
      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partOne.isSubjectToRegulation.label'
        )}
        name="isSubjectToRegulation"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />
      {values.isSubjectToRegulation?.value === YesOrNoType.Yes && (
        <>
          <Field.Text
            label={t(
              'onboarding.companyGlobalFinancialMonitoring.partOne.supervisoryAuthorityNameAndLocation.label'
            )}
            maxLength={maxLengthTextField}
            name="supervisoryAuthorityNameAndLocation"
            placeholder={t(
              'onboarding.companyGlobalFinancialMonitoring.partOne.supervisoryAuthorityNameAndLocation.placeholder'
            )}
          />

          <Field.Autocomplete
            label={t(
              'onboarding.companyGlobalFinancialMonitoring.partOne.mandatoryAmlRegulation.hasMandatoryAmlRegulations.label'
            )}
            name="mandatoryAmlRegulation.hasMandatoryAmlRegulations"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.select.placeholder')}
            variant="select"
          />
          {values.mandatoryAmlRegulation?.hasMandatoryAmlRegulations?.value ===
            YesOrNoType.Yes && (
            <>
              <Field.Text
                label={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.mandatoryAmlRegulation.regulationDetails.label'
                )}
                maxLength={maxLengthTextField}
                name="mandatoryAmlRegulation.regulationDetails"
                placeholder={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.mandatoryAmlRegulation.regulationDetails.placeholder'
                )}
              />
              <Field.Text
                label={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.mandatoryAmlRegulation.authorizedBodyName.label'
                )}
                maxLength={maxLengthTextField}
                name="mandatoryAmlRegulation.authorizedBodyName"
                placeholder={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.mandatoryAmlRegulation.authorizedBodyName.placeholder'
                )}
              />
            </>
          )}

          <Field.Text
            showOptionalMark
            label={t(
              'onboarding.companyGlobalFinancialMonitoring.partOne.lastAmlAuditResult.label'
            )}
            maxLength={maxLengthTextField}
            name="lastAmlAuditResult"
            placeholder={t(
              'onboarding.companyGlobalFinancialMonitoring.partOne.lastAmlAuditResult.placeholder'
            )}
          />

          <Field.Autocomplete
            label={t(
              'onboarding.companyGlobalFinancialMonitoring.partOne.investigationsOrSanctions.hadInvestigationsOrSanctions.label'
            )}
            name="investigationsOrSanctions.hadInvestigationsOrSanctions"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.select.placeholder')}
            variant="select"
          />
          {values.investigationsOrSanctions?.hadInvestigationsOrSanctions
            ?.value === YesOrNoType.Yes && (
            <Field.Text
              label={t(
                'onboarding.companyGlobalFinancialMonitoring.partOne.investigationsOrSanctions.amlDecisionDateAndAuthorityInfo.label'
              )}
              maxLength={maxLengthTextField}
              name="investigationsOrSanctions.amlDecisionDateAndAuthorityInfo"
              placeholder={t(
                'onboarding.companyGlobalFinancialMonitoring.partOne.investigationsOrSanctions.amlDecisionDateAndAuthorityInfo.placeholder'
              )}
            />
          )}

          <Field.Autocomplete
            label={t(
              'onboarding.companyGlobalFinancialMonitoring.partOne.internalAmlDocuments.hasInternalAmlDocuments.label'
            )}
            name="internalAmlDocuments.hasInternalAmlDocuments"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.select.placeholder')}
            variant="select"
          />
          {values.internalAmlDocuments?.hasInternalAmlDocuments?.value ===
            YesOrNoType.Yes && (
            <>
              <Field.DatePicker
                label={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.internalAmlDocuments.adoptionDate.label'
                )}
                name="internalAmlDocuments.adoptionDate"
                placeholder={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.internalAmlDocuments.adoptionDate.placeholder'
                )}
              />
              <Field.DatePicker
                label={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.internalAmlDocuments.lastUpdateDate.label'
                )}
                name="internalAmlDocuments.lastUpdateDate"
                placeholder={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.internalAmlDocuments.lastUpdateDate.placeholder'
                )}
              />
              <Field.Autocomplete
                label={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.internalAmlDocuments.hasEffectivenessAssessmentProcedures.label'
                )}
                name="internalAmlDocuments.hasEffectivenessAssessmentProcedures"
                optionLabelKey="label"
                options={getYesOrNoOptions(t)}
                optionValueKey="value"
                placeholder={t('common.select.placeholder')}
                variant="select"
              />
              {values.internalAmlDocuments?.hasEffectivenessAssessmentProcedures
                ?.value === YesOrNoType.Yes && (
                <Field.Text
                  label={t(
                    'onboarding.companyGlobalFinancialMonitoring.partOne.internalAmlDocuments.lastEffectivenessCheckInfo.label'
                  )}
                  maxLength={maxLengthTextField}
                  name="internalAmlDocuments.lastEffectivenessCheckInfo"
                  placeholder={t(
                    'onboarding.companyGlobalFinancialMonitoring.partOne.internalAmlDocuments.lastEffectivenessCheckInfo.placeholder'
                  )}
                />
              )}
              <Field.Autocomplete
                showOptionalMark
                label={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.internalAmlDocuments.appliesToForeignAffiliates.label'
                )}
                name="internalAmlDocuments.appliesToForeignAffiliates"
                optionLabelKey="label"
                options={getYesOrNoOptions(t)}
                optionValueKey="value"
                placeholder={t('common.select.placeholder')}
                variant="select"
              />
            </>
          )}

          <Field.Autocomplete
            label={t(
              'onboarding.companyGlobalFinancialMonitoring.partOne.departmentsResponsibleForAmlFunctions.hasDepartmentsResponsibleForAmlFunctions.label'
            )}
            name="departmentsResponsibleForAmlFunctions.hasDepartmentsResponsibleForAmlFunctions"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.select.placeholder')}
            variant="select"
          />
          {values.departmentsResponsibleForAmlFunctions
            ?.hasDepartmentsResponsibleForAmlFunctions?.value ===
            YesOrNoType.Yes && (
            <Field.Text
              label={t(
                'onboarding.companyGlobalFinancialMonitoring.partOne.departmentsResponsibleForAmlFunctions.amlFunctionDepartmentsNames.label'
              )}
              maxLength={maxLengthTextField}
              name="departmentsResponsibleForAmlFunctions.amlFunctionDepartmentsNames"
              placeholder={t(
                'onboarding.companyGlobalFinancialMonitoring.partOne.departmentsResponsibleForAmlFunctions.amlFunctionDepartmentsNames.placeholder'
              )}
            />
          )}

          <Field.Autocomplete
            label={t(
              'onboarding.companyGlobalFinancialMonitoring.partOne.responsibleAmlManager.hasResponsibleAmlManager.label'
            )}
            name="responsibleAmlManager.hasResponsibleAmlManager"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.select.placeholder')}
            variant="select"
          />
          {values.responsibleAmlManager?.hasResponsibleAmlManager?.value ===
            YesOrNoType.Yes && (
            <>
              <Field.Text
                label={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.responsibleAmlManager.fullName.label'
                )}
                maxLength={maxLengthTextField}
                name="responsibleAmlManager.fullName"
                placeholder={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.responsibleAmlManager.fullName.placeholder'
                )}
              />
              <Field.Text
                label={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.responsibleAmlManager.position.label'
                )}
                maxLength={maxLengthTextField}
                name="responsibleAmlManager.position"
                placeholder={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.responsibleAmlManager.position.placeholder'
                )}
              />
              <Field.Text
                label={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.responsibleAmlManager.email.label'
                )}
                name="responsibleAmlManager.email"
                placeholder={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.responsibleAmlManager.email.placeholder'
                )}
                type="email"
              />
              <Field.Phone
                label={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.responsibleAmlManager.phoneNumber.label'
                )}
                maxLength={22}
                name="responsibleAmlManager.phoneNumber"
                placeholder={t(
                  'onboarding.companyGlobalFinancialMonitoring.partOne.responsibleAmlManager.phoneNumber.placeholder'
                )}
                type="phone"
              />
            </>
          )}

          <Field.Autocomplete
            label={t(
              'onboarding.companyGlobalFinancialMonitoring.partOne.hasRiskManagementProcedures.label'
            )}
            name="hasRiskManagementProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.select.placeholder')}
            variant="select"
          />
        </>
      )}
    </>
  );
};
